import { render, staticRenderFns } from "./AAttachmentUploadList.vue?vue&type=template&id=07120030&scoped=true&"
import script from "./AAttachmentUploadList.vue?vue&type=script&lang=ts&"
export * from "./AAttachmentUploadList.vue?vue&type=script&lang=ts&"
import style0 from "./AAttachmentUploadList.vue?vue&type=style&index=0&id=07120030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07120030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
